/// <reference path="Utilities/_reference.ts" />

/**
 * Handlebars helper module
 */
Handlebars.registerHelper('contains', function (value, test, options) {
	if (value.includes(test)) {
		return options.fn(this);
	} else {
		return options.inverse(this);
	}
});

Handlebars.registerHelper('ifCond', function (v1, operator, v2, options) {
	switch (operator) {
		case '!=': {
			return (v1 !== v2) ? options.fn(this) : options.inverse(this);
		}

		case '===': {
			return (v1 === v2) ? options.fn(this) : options.inverse(this);
		}

		case '<': {
			return (v1 < v2) ? options.fn(this) : options.inverse(this);
		}

		case '<=': {
			return (v1 <= v2) ? options.fn(this) : options.inverse(this);
		}

		case '>': {
			return (v1 > v2) ? options.fn(this) : options.inverse(this);
		}

		case '>=': {
			return (v1 >= v2) ? options.fn(this) : options.inverse(this);
		}

		case '&&': {
			return (v1 && v2) ? options.fn(this) : options.inverse(this);
		}

		case '||': {
			return (v1 || v2) ? options.fn(this) : options.inverse(this);
		}

		default: {
			return options.inverse(this);
		}
	}
});

Handlebars.registerHelper('is', function (value, test, options) {
	if (value === test) {
		return options.fn(this);
	} else {
		return options.inverse(this);
	}
});

Handlebars.registerHelper('isnt', function (value, test, options) {
	if (value !== test) {
		return options.fn(this);
	} else {
		return options.inverse(this);
	}
});

Handlebars.registerHelper('increment', (value, options) => parseInt(value, 10) + 1);

Handlebars.registerHelper('decrement', (value, options) => parseInt(value, 10) - 1);

Handlebars.registerHelper('subtract', (value, subtraction, options) => value - subtraction);

Handlebars.registerHelper('toLowerCase', value => {
	if (value && value.toLowerCase) {
		return value.toLowerCase();
	}

	return value;
});

Handlebars.registerHelper('toUpperCase', value => {
	if (value && value.toUpperCase) {
		return value.toUpperCase();
	}

	return value;
});

Handlebars.registerHelper('format', (key: string, value, options) => {
	if (key && key.format) {
		return key.format(value);
	}

	return key;
});

Handlebars.registerHelper('formatISOTime', (time: string, options) => {
	if (time) {
		return YVR.Utilities.Dates.formatISOTime(time);
	}

	return time;
});

Handlebars.registerHelper('formatShortTime', (time: string, options) => {
	if (time) {
		return YVR.Utilities.Dates.formatShortTime(time);
	}

	return time;
});

Handlebars.registerHelper('formatMonthDay', (time: string, options) => {
	if (time) {
		return YVR.Utilities.Dates.formatMonthDay(time);
	}

	return time;
});

Handlebars.registerHelper('formatLongDate', (time: string, options) => {
	if (time) {
		return YVR.Utilities.Dates.formatLongDate(time);
	}

	return time;
});

Handlebars.registerHelper('formatShortDateTime', (time: string, options) => {
	if (time) {
		return YVR.Utilities.Dates.formatShortDateTime(time);
	}

	return time;
});

Handlebars.registerHelper('formatFullMonthDay', (time: string, options) => {
	if (time) {
		return YVR.Utilities.Dates.formatFullMonthDay(time);
	}

	return time;
});


Handlebars.registerHelper('nowrap', value => {
	if (value && value.replace) {
		return value.replace(/\s/gi, '&nbsp;');
	}

	return value;
});

Handlebars.registerHelper('encodeURIComponent', value => {
	if (value) {
		return encodeURIComponent(value);
	}

	return '';
});

Handlebars.registerHelper('stringify', (object: Object) => JSON.stringify(object));

Handlebars.registerHelper('replaceSpace', function (aString) {

	if (aString == null) {
		return '';
	} else {
		aString = aString.replace(/\s+/g, '-').toLowerCase();
		aString = aString.replace(/&/g, '');
		return aString;
	}
});

Handlebars.registerHelper('displayThree', function (aString) {

	if (aString == null) {
		return '';
	} else {
		//aString = aString.replace(/\s+/g, '').toLowerCase();
		aString = aString.replace(/&/g, ',');

		let split = aString.split(',');


		let keywords = '';

		for (let i = 0; i < split.length && i < 3; i++) {


			keywords += split[i].trim();

			if (i < 2 && i < split.length - 1) {
				keywords += ' | ';
			}
		}
		return keywords;
	}
});

Handlebars.registerHelper('formatLink', function (aString) {

	if (aString == null) {
		return '';
	} else {


		aString = aString.replace('http://', '').replace('https://', '');

		//replace trailing slash
		if (aString.endsWith('/')) {
			aString = aString.slice(0, -1);
		}

		return aString;
	}
});

Handlebars.registerHelper('formatPhone', function (aString) {

	if (aString == null) {
		return '';
	} else {

		aString = aString.replace('+', '');

		return aString;
	}
});

Handlebars.registerHelper('formatTerminal', function (aString) {

	if (aString == null) {
		return '';
	} else {

		if (aString === 'I') {
			return 'international';
		} else if (aString === 'D') {
			return 'domestic';
		} else if (aString === 'T') {
			return 'usa';
		} else if (aString === 'S') {
			return 'south';
		}

		return aString;
	}
});

// Handlebar helper to clear
Handlebars.registerHelper('formatCity', function (aString) {

	console.log('a string', aString);

	if (aString == null) {
		return '';
	}

	aString = aString
		.normalize("NFD").replace(/[\u0300-\u036f]/g, "") // remove accents
		.toLowerCase()
		.replace(/\s+/g, "-") // replace spaces with -
		.replace('.', '');

	return aString;
});

function capitalizeFirstLetter(string) {
	return string.charAt(0).toUpperCase() + string.slice(1);
}

